import React from 'react'
import Link from 'gatsby-link'
import { Helmet } from "react-helmet";

import Slider from 'react-slick';

import CoverHomepage from '../assets/cover-homepage.jpg';

import Block from '../components/block';
import Title from '../components/my-title';

import BlockCover from '../components/block-cover';
import BlockReassurance from '../components/block-reassurance';
import BlockContent from '../components/block-content';

import HomepageOurExpertiseImage from '../assets/homepage-our-expertise.jpg';
import HomepageOurExpertiseBackgroundImage from '../assets/homepage-our-expertise-background.jpg';

import HomepageAtelierImage from '../assets/homepage-atelier.jpg';
import HomepageAtelierBackgroundImage from '../assets/homepage-atelier-background.jpg';

import HomepageDeliveryImage from '../assets/homepage-delivery.jpg';
import HomepageDeliveryBackgroundImage from '../assets/homepage-delivery-background.jpg';

import data from '../data';

const BlockExpertiseHomepage = ({ title, imageUrl, to, height }) => (
  <Link to={to} className="block-expertise-homepage-item mb-3 mt-3" style={Object.assign(
    imageUrl ? {
      backgroundImage: `url(${imageUrl})`
    } : {},
    height ? {
      height: height
    } : {}
  )}>
    <span
      className="block-expertise-homepage-item-title">{title}</span>
  </Link>
)

const IndexPage = () => (
  <div className="big-title">
    <Helmet>
      <title>Didier Bré, artisan menuisier à Paris : créations sur mesure</title>
      <meta name="description" content="Didier Bré réalise tous vos projets de menuiserie sur mesure à Paris et dans l'Ouest Parisien. Devis gratuits, conseils personnalisés et fabrication française." />
    </Helmet>
    <BlockCover
      backgroundUrl={CoverHomepage}
      title="Didier Bré, artisan menuisier."
      subtitle="Ce dont vous rêvez, il le crée."
    >
      <p>
        Naturel et noble par excellence, le bois est propice au rêve…<br />
        Un rêve qui peut devenir réalité avec une création sur mesure, qui reflète exactement votre vision,  qui cadre précisément avec votre mode de vie.<br />
        Une création dont vous vous demanderez comment vous avez pu vous en passer.<br />
        Imaginer et réaliser sur-mesure votre mobilier, votre terrasse, votre parquet, c’est la passion de Didier Bré,  nourrie par 30 ans de savoir-faire. Tout le plaisir d’un meuble ou d’un agencement élégant, raffiné, fonctionnel, parfaitement adapté à vos goûts et vos besoins, c’est auprès de lui que vous le trouverez.<br />
        Et à un prix beaucoup plus accessible que vous ne l’imaginez.
      </p>
      <Link to="/projet" className="btn btn-light mr-3">J'ai un projet</Link>
      <Link to="/architecte" className="btn btn-light btn-light-thin">Je suis un architecte</Link>
    </BlockCover>
    <BlockReassurance />

    <BlockContent
      backgroundUrl={HomepageOurExpertiseBackgroundImage}
      imageUrl={HomepageOurExpertiseImage}
      title="Notre organisation"
      hasDecoration={true}>
      <h3 className="light fs-27 color-red lh-32 mb-1">Une équipe qualifiée<br />à votre écoute</h3>
      <p className="light fs-16 mb-2">Force de proposition et d'optimisation</p>
      <p className="light fs-15 color-grey mb-3">
        Comprendre vos envies, vos goûts, vos besoins est essentiel pour traduire concrètement ce que vous imaginez.<br />
        C’est pourquoi après un premier entretien téléphonique où nous définissons ensemble vos attentes, nous convenons avec vous d’une réunion de travail. Là, nous vous présentons notre approche créative, nos conseils de réalisation et notre proposition budgétaire. Cette première étape occupe un rôle majeur dans le cadrage de votre projet, c’est pourquoi Didier Bré, son chef d’atelier ainsi que nos différents corps de métier sont le plus souvent présents, mettant toute la palette de nos compétences à votre service. Cette phase de préparation achevée, la fabrication peut alors commencer. Quatre à six semaines plus tard, vous profitez chez vous d’un meuble, d’un agencement qui accompagne parfaitement votre quotidien.
      </p>
      <Link to="/atelier#l-equipe" className="btn btn-black btn-black-thin btn-right-arrow">Découvrez l'équipe</Link>
    </BlockContent>

    <BlockContent
      backgroundUrl={HomepageAtelierBackgroundImage}
      imageUrl={HomepageAtelierImage}
      reverse={true}>
      <h3 className="light fs-27 color-red lh-32 mb-1">Un atelier performant</h3>
      <p className="light fs-16 mb-2">à la hauteur de votre imagination</p>
      <p className="light fs-15 color-grey mb-3">
        Les belles idées doivent pouvoir s’épanouir librement, sans être bridées par les contraintes techniques. C’est pourquoi, outre notre savoir-faire et notre goût affirmé du travail bien fait, nous mettons à votre disposition un atelier abritant le nec plus ultra des machines de dernière génération, dédiées à la réalisation de pièces uniques. Précision des découpes, qualité des finitions, tout est réuni pour faire de votre projet une réussite.<br />
        Et comme nous sommes fiers de ce que nous accomplissons, notre atelier vous est ouvert, pour y découvrir les essences de bois, rencontrer les équipes, ou affiner votre projet avec notre chef d’atelier. Vous êtes le bienvenu parmi nous.

      </p>
      <Link to="/atelier" className="btn btn-black btn-black-thin btn-right-arrow">Découvrez l'atelier</Link>
    </BlockContent>

    <BlockContent
      backgroundUrl={HomepageDeliveryBackgroundImage}
      imageUrl={HomepageDeliveryImage}>
      <h3 className="light fs-27 color-red lh-32 mb-1">Un transport adapté</h3>
      <p className="light fs-16 mb-2">une pose de haute qualité</p>
      <p className="light fs-15 color-grey mb-3">
        Guidés par une constante volonté d’excellence, nos techniciens déploient rigueur et expertise tout au long de la fabrication, qui inclut des contrôles qualité à chaque étape.<br />
        La livraison et l’installation se doivent à nos yeux de respecter le même standard élevé d’exigence. C’est pourquoi, là encore, nous veillons lors de ces étapes cruciales à apporter un soin méticuleux à nos réalisations, parfaitement protégées et assemblées dans les règles de l’art.<br />
        La vigilance de notre équipe vous garantit l’intégration harmonieuse de votre nouveau mobilier dans votre univers.


      </p>
      <Link to="/realisations" className="btn btn-black btn-black-thin btn-right-arrow">Nos réalisations</Link>
    </BlockContent>

    <Block hasDecoration>
      <Title>Ce que nous faisons</Title>

      <div className="block-expertise-homepage">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-12">
                  <BlockExpertiseHomepage
                    title="Parquet"
                    imageUrl="/home/expertise/parquet.jpg"
                    to="/expertise"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <BlockExpertiseHomepage
                    title="Bibliothèque"
                    imageUrl="/home/expertise/bibliotheque.jpg"
                    to="/expertise"
                  />
                </div>
                <div className="col-md-6">
                  <BlockExpertiseHomepage
                    title="Terrasse"
                    imageUrl="/home/expertise/terrasse.jpg"
                    to="/expertise"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <BlockExpertiseHomepage
                title="Cuisine"
                imageUrl="/home/expertise/cuisine.jpg"
                to="/expertise"
                height="530"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="text-align-center mt-5 mb-4">
        <Link to="/expertise" className="btn btn-primary btn-primary-thin btn-min-width-300">Voir plus</Link>
      </div>
    </Block>

    <Block hasDecoration backgroundColor="#EFF2F4">
      <Title>Nos réalisations</Title>

      <Slider
        className="slider"
        dots={false}
        infinite={true}
        slidesToShow={3}
        slidesToScroll={1}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          },
        ]}>
        {data.default.map((item, index) => (
          <div className="slider-item-container" key={index}>
            <div className="slider-item">
              <div className="slider-item-background">
                <img className="w-100 img-fluid" src={item.defaultImageUrl} alt={item.title} />
              </div>
              <div className="slider-item-content">
                <p className="mb-0 color-white uppercase bold fs-17 lh-20">{item.title}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <div className="text-align-center mt-5">
        <Link to="/realisations" className="btn btn-primary btn-primary-thin btn-min-width-300">Voir toutes nos réalisations</Link>
      </div>
    </Block>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js